// extracted by mini-css-extract-plugin
export default {"dialogo":"DialogoConfirmacion_dialogo__fUSrg","check":"DialogoConfirmacion_check__g1yyR"};